import { REGISTER_TO_EVENT, UNREGISTER_FROM_EVENT } from "./queries";
import { client } from "apollo.js";

export const registerToEvent = async (eventId, currentLang, eventType) => {
  const result = await client.mutate({
    mutation: REGISTER_TO_EVENT,
    variables: { eventId, currentLang, eventType },
  });
  return result;
};

export const unregisterFromEvent = async (eventId, currentLang, eventType) => {
  const result = await client.mutate({
    mutation: UNREGISTER_FROM_EVENT,
    variables: { eventId, currentLang, eventType },
  });
  return result;
};
